import React, { useEffect, useRef } from "react";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { useState } from "react";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { eCardAction, inmateAction, masterActions, publicUserActions } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import CustomPhoto from "../../composables/CustomPhoto";

function SentEcardDetails() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { REACT_APP_API_IMAGE_URL } = process.env;
  const { source, row, Inmate } = location.state || {};
  const ecardID = location?.state?.ecardID ? location?.state?.ecardID : 0;

  const { getSentEcardInfoResponse, loading } = useSelector((x) => x?.ecard);

  const { commonFacilityCode } = useSelector((state) => state.auth);
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  const [rotation, setRotation] = useState(0);
  const [rotationForPopup, setRotationForPopup] = useState(0);
  const [isZoom, setIsZoom] = useState(false);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("/Admin/Ecards/sent");
    }
  }, [commonFacilityCode]);

  /* facility drop down */
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, []);

  useEffect(() => {
    if (ecardID === 0) return;
    dispatch(eCardAction?.getSentEcardInfo(ecardID));
  }, [ecardID]);

  const data = [
    {
      label: "Subject",
      value: getSentEcardInfoResponse?.EcardSubject || "",
    },
    { label: "From", value: getSentEcardInfoResponse?.EcardFrom || "-" },
    { label: "To", value: getSentEcardInfoResponse?.EcardTo || "-" },
    {
      label: "Sent On",
      value: getSentEcardInfoResponse?.SentDateMobile || "-",
    },
    {
      label: "Category",
      value: getSentEcardInfoResponse?.CategoryName || "-",
    },
    {
      label: "Read Status",
      value: getSentEcardInfoResponse?.ReadStaus || "-",
    },
    {
      label: "Customized",
      value: getSentEcardInfoResponse?.Envelopecolor ? "Yes" : "No" || "-",
    },
  ];

  const columns = [
    {
      width: "180px",
      name: "E-CARD DESCRIPTION",
      selector: (row) => row.label,
      sortable: false,
      cell: (row) => (
        <div className="doc-name">
          <div>{row.label}</div>
        </div>
      ),
    },
    {
      name: "",
      selector: (row) => row.value,
      sortable: false,
    },
  ];

  // Function to handle rotation
  const rotateImage = (angle) => {
    setRotation((prevRotation) => prevRotation + angle);
  };

  const handleBack = () => {
    if (source === "publicUserEcard") {
      dispatch(publicUserActions?.setPublicUserTab("publicuser-ecard-tab"));
      history.navigate("/Admin/PublicUserList/Details", {
        state: {
          row: row,
        },
      });
    }
    else if (source === "InmateEcard") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-ecard-tab"));
      history.navigate("InmateList/Details", {
        state: { inmate: Inmate, showTransactionTab: false },
      });
    }
    else {
      history?.navigate("/Admin/E-Cards/Sent");
    }
  }
  const handleZoom = () => {
    setIsZoom(true);
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space">
          <h2 className=" text-color">E-CARD INFORMATION</h2>
          <div className="d-flex flex-wrap">
            <Button
              label="Back"
              type="button"
              //className="btn btn-danger me-2"
              onClick={() => handleBack()}
              variant="danger"
              status={"primary"}
              disabled={false}
              icon={"fa-solid fa-angle-left"}
            />
          </div>
        </div>

        <div className="row mt-3">
          {/* {rotation} */}
          <div className="col-md-6 col-lg-6 col-sm-12 p-2 border border-dark-grey">
            <div className="fs-5 px-4 py-3 d-flex flex-wrap justify-content-center">
              {/* Rotate Left Icon */}
              <i
                className="fas fa-lg fa-fw me-10px fa-rotate-right"
                onClick={() => rotateImage(90)}
                style={{ cursor: "pointer" }}
                title="Rotate 90°"
              ></i>
              <i
                className="fas fa-lg fa-fw me-10px fa-arrows-rotate"
                onClick={() => rotateImage(180)}
                style={{ cursor: "pointer" }}
                title="Rotate 180°"
              ></i>
              {/* Rotate Right Icon */}
              <i
                className="fas fa-lg fa-fw me-10px fa-rotate-left"
                onClick={() => rotateImage(-90)}
                style={{ cursor: "pointer" }}
                title="Rotate -90°"
              ></i>
            </div>

            <div className="card-body p-2">
              {/* Rotatable Image */}
              <div className="d-flex justify-content-center align-items-center p-2"
              // style={{
              //   position: "relative",
              //   height: "100%",
              //   overflow: "hidden",
              //   margin: "0 auto",
              // }}
              >
                {/* Stretched Image */}

                <img
                  // style={{
                  //   width: "100%",
                  //   height: "100%",
                  //   transform: `rotate(${rotation}deg)`,
                  //   transformOrigin: "center center",
                  //   transition: "transform 0.3s ease",
                  // }}
                  style={{
                    transform: `rotate(${rotation}deg)`,
                    height: '100%',
                    objectFit: 'contain', // Ensures the full image is displayed
                    marginTop: '0', // Adjust margin if needed
                    maxHeight: '50vh',
                    minHeight: '50vh',
                    minWidth: '55vh', maxWidth: '55vh'
                  }}
                  onClick={() => handleZoom()}
                  src={
                    getSentEcardInfoResponse?.EcardFilePath ? REACT_APP_API_IMAGE_URL +
                      getSentEcardInfoResponse?.EcardFilePath : null
                  }
                  alt="ecard"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 p-2 border border-dark-grey">
            <div className="card-body">
              <Table columns={columns} data={data} />
            </div>
          </div>
        </div>
        {isZoom &&
          <CustomPhoto
            // ecardFilePath
            imgsrc={
              getSentEcardInfoResponse?.EcardFilePath
                ? REACT_APP_API_IMAGE_URL +
                getSentEcardInfoResponse?.EcardFilePath
                : ""
            }
            isZommImage={isZoom}
            setisZommImage={setIsZoom}
            rotation={rotationForPopup}
            setRotation={setRotationForPopup}
          />}
      </div>
    </>
  );
}

export default React.memo(SentEcardDetails);
